import React, { useState, useEffect } from "react";
import "./LoadingPage.css";

// 언어별 로딩 메시지 번역 추가
const loadingTranslations = {
  ko: "쉽고, 편하고, 깔끔한 연구를 위해!",
  en: "For easy, comfortable, and clean research!",
  ja: "簡単で、快適で、きれいな研究のために！",
  "zh-CN": "为简单、舒适、干净的研究！",
  "zh-TW": "為簡單、舒適、乾淨的研究！",
  it: "Per una ricerca facile, comoda e pulita!",
  fr: "Pour une recherche facile, confortable et propre !",
  de: "Für einfache, komfortable und saubere Forschung!",
  es: "¡Para una investigación fácil, cómoda y limpia!",
  ru: "Для лёгких, удобных и чистых исследований!",
  pt: "Para pesquisas fáceis, confortáveis e limpas!",
  ar: "لبحث سهل، مريح ونظيف!",
  hi: "आसान, आरामदायक, और साफ़-सुथरे शोध के लिए!",
};

const LoadingPage = () => {
  const [loadingMessage, setLoadingMessage] = useState(loadingTranslations.ko); // 기본값은 한국어

  // 컴포넌트 마운트 시 로컬스토리지에서 언어 설정 가져오기
  useEffect(() => {
    const savedLanguage = localStorage.getItem("i2m_language") || "ko";

    // 해당 언어의 로딩 메시지가 있으면 사용, 없으면 영어 또는 한국어로 폴백
    if (loadingTranslations[savedLanguage]) {
      setLoadingMessage(loadingTranslations[savedLanguage]);
    } else if (loadingTranslations.en) {
      setLoadingMessage(loadingTranslations.en);
    }
  }, []);

  return (
    <div className="loading-page">
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <h2 className="loading-message">{loadingMessage}</h2>
      </div>
    </div>
  );
};

export default LoadingPage;
